import { onDocumentReady } from 'scripts/util/events'

onDocumentReady(() => {
  setTimeout(() => {
    //check for element on page
    const agendaItemsContainer = document.querySelectorAll(
      '.table-agenda-items'
    )
    if (agendaItemsContainer.length > 0) {
      //get all children to check if we need to activete toggle option
      let agendaItems = agendaItemsContainer[0].getElementsByClassName(
        'table-agenda-item'
      )
      //toggle only 4+ items and mobile
      if (agendaItems.length > 3 && window.innerWidth < 768) {
        //get buttons
        let moreButton = agendaItemsContainer[0].getElementsByClassName(
            'show-more'
          ),
          lessButton = agendaItemsContainer[0].getElementsByClassName(
            'show-less'
          )
        //check for buttons text exist
        if (moreButton.length && lessButton.length) {
          agendaItemsContainer[0].classList.add('expanded')
          moreButton[0].classList.add('active')
          //show more button click
          moreButton[0].addEventListener('click', () => {
            moreButton[0].classList.remove('active')
            lessButton[0].classList.add('active')
            agendaItemsContainer[0].classList.add('full')
          })
          //show less button click
          lessButton[0].addEventListener('click', () => {
            lessButton[0].classList.remove('active')
            moreButton[0].classList.add('active')
            agendaItemsContainer[0].classList.remove('full')
          })
        }
      }
    }
  }, 500)
})
